export const BACKEND_STATUS_EVENT = 'nexo:backend-status';

export type BackendStatus = 'available' | 'unavailable';

export const reportBackendStatus = (status: BackendStatus) => {
  if (typeof window === 'undefined') {
    return;
  }

  window.dispatchEvent(
    new CustomEvent<BackendStatus>(BACKEND_STATUS_EVENT, { detail: status }),
  );
};
